export class SensitivityAnnotation {
    'filePath';
    'propertyName';
    'propertyValue';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filePath",
            "baseName": "filePath",
            "type": "string",
            "format": ""
        },
        {
            "name": "propertyName",
            "baseName": "propertyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "propertyValue",
            "baseName": "propertyValue",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensitivityAnnotation.attributeTypeMap;
    }
    constructor() {
    }
}
